import axios from 'axios'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  // Устанавливаем глобальный таймаут в 10 минуты (600000 мс)
  // Для длительных запросов можно переопределить в конкретном запросе
  timeout: 600000,
})

export default api
